import React from 'react';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import type {JobHazardAnalysisSimpleResponse} from 'src/api/ProactApiClient';
import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {TableToolbar} from 'src/design/molecules/TableToolbar';
import {SidebarLinkJobHazardAnalysis} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {JobHazardAnalysisTable} from 'src/app/job-hazard-analysis/JobHazardAnalysisTable/JobHazardAnalysisTable';
import {jhaDocumentTitle} from 'src/app/job-hazard-analysis/jobHazardAnalysisHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useJHAPermissions} from 'src/shared/auth/permissions/useJHAPermissions';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export const JobHazardAnalysisListPage: React.FC = () => {
  useSetDocumentTitle(jhaDocumentTitle);
  const navigate = useAppNavigate();
  const jhaPerms = useJHAPermissions();

  const handleAddNew = () => navigate(PathUtility.JobHazardAnalysisCreate());

  const handleNavigateTo = (row: JobHazardAnalysisSimpleResponse) =>
    navigate(PathUtility.JobHazardAnalysisView(String(row.id), 'content'));

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.JobHazardAnalysis}>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkJobHazardAnalysis.icon}
          subtitle="Track and manage job hazard analyses">
          Job Hazard Analysis
        </PageHeader.Title>
      </PageHeader>
      <JobHazardAnalysisTable
        identifier="job-hazard-analysis-table"
        onViewRowClick={handleNavigateTo}
        actionBarPreNode={
          jhaPerms.create ? (
            <TableToolbar.Action variant="create" onClick={handleAddNew}>
              New JHA
            </TableToolbar.Action>
          ) : undefined
        }
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.JobHazardAnalysis(),
  element: <JobHazardAnalysisListPage />,
  isPrivate: true,
});
